module.exports = require('./lower-case');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/string/lc.js
// module id = 313
// module chunks = 0 1 2